export const environment = {
    production: true,
    domain: 'https://staging.fotofinder.de',
    url_be : 'https://proposer-be-stg.fotofinderhub.de'
};
